"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const AccessData_1 = __importDefault(require("@becrop/components/Profile/Access/class/models/AccessData"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const DistributorImgsList_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/DistributorImgsList.vue"));
const ModalIndividualGrantAccess_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ModalIndividualGrantAccess.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const ViewZero_vue_1 = __importDefault(require("../components/ViewZero.vue"));
let TableProjects = class TableProjects extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.checkContainer = [];
        this.isCheckedGlobal = false;
        this.norepeat = [];
        this.isIndividualGrantAccessModal = false;
        this.selectedSampleId = 0;
        this.selectedProjectId = 0;
    }
    get projectsFilter() {
        return this.dataSet.filterProjects(this.textSearch, this.cropsFilters, this.filterAccess);
    }
    get projectsPagination() {
        return this.dataSet.projectsPgi;
    }
    resetCheckedGlobal() {
        this.isCheckedGlobal = false;
        this.checkContainer = [];
    }
    resetItemsCheck() {
        this.checkContainer = [];
        this.isCheckedGlobal = false;
        this.$emit('projectsIds', []);
    }
    recall() {
        this.$emit('recall');
    }
    individualProjectRevoke(data) {
        this.$emit('individualProjectRevoke', data);
    }
    openIndividualGrantAccessModal() {
        this.isIndividualGrantAccessModal = true;
    }
    dismissIndividualGrantAccessModal() {
        this.isIndividualGrantAccessModal = false;
        this.checkContainer = [];
        this.isCheckedGlobal = false;
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
        if (!this.isCheckedGlobal)
            this.checkContainer = [];
    }
    changeIsSampleSelected(newValue, sampleId) {
        this.pushFn(sampleId);
    }
    pushFn(id) {
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
        }
        if (this.checkContainer.includes(id)) {
            this.checkContainer = this.checkContainer.filter((item) => item !== id);
        }
        else {
            this.checkContainer.push(id);
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.norepeat = notRepeat;
        this.$emit('projectsIds', notRepeat);
    }
    checkedGlobalObserver() {
        if (this.isCheckedGlobal) {
            for (const project of this.textSearch.length > 0 ||
                this.cropsFilters.length > 0 ||
                this.filterAccess.length > 0
                ? this.dataSet.filterProjects(this.textSearch, this.cropsFilters, this.filterAccess)
                : this.dataSet.projectsPagination) {
                this.checkContainer.push(project.meta.id);
            }
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.$emit('projectsIds', notRepeat);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProjects.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new AccessData_1.default() })
], TableProjects.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableProjects.prototype, "isResetItemsCheck", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], TableProjects.prototype, "textSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], TableProjects.prototype, "cropsFilters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], TableProjects.prototype, "filterAccess", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dataSet.currentPage')
], TableProjects.prototype, "resetCheckedGlobal", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('textSearch'),
    (0, vue_property_decorator_1.Watch)('cropsFilters'),
    (0, vue_property_decorator_1.Watch)('isResetItemsCheck'),
    (0, vue_property_decorator_1.Watch)('filterAccess')
], TableProjects.prototype, "resetItemsCheck", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], TableProjects.prototype, "checkedGlobalObserver", null);
TableProjects = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            CheckBox: bmk_ui_framework_1.CheckBox,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            Tag: bmk_ui_framework_1.Tag,
            Loader: bmk_ui_framework_1.Loader,
            DateStylized: bmk_ui_framework_1.DateStylized,
            DistributorImgsList: DistributorImgsList_vue_1.default,
            Plus: lucide_vue_next_1.Plus,
            ModalIndividualGrantAccess: ModalIndividualGrantAccess_vue_1.default,
            ViewZero: ViewZero_vue_1.default,
            WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon,
        },
    })
], TableProjects);
exports.default = TableProjects;
